import { useCallback } from 'react';
import { Typography, makeStyles, IconButton } from '@material-ui/core';
import { Clear as ClearIcon } from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { setDateRange } from '../../../../../redux_store';
import CalendarPopover from '../../../../FormikFields/Calendar/CalendarPopover';

const useStyles = makeStyles((theme) => ({
  controlGroup: {
    flex: '0 0 auto',
    paddingBottom: theme.spacing(0),
    borderBottom: 'none',
    marginBottom: theme.spacing(0),

    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(2),
      borderBottom: 'none',
      marginBottom: theme.spacing(2),
    },
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 1.5,
    textTransform: 'uppercase',
    color: '#9196A6',
    marginBottom: theme.spacing(1.5),
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  calendarWrapper: {
    flex: 1,
  },
  clearButton: {
    padding: 4,
    color: '#9196A6',
    '&:hover': {
      color: '#6B7280',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  inputClass: {
    fontSize: 15,
  },
  inputPlaceholderClass: {
    fontSize: 13,
  },
}));

const DateRangeFilter = ({ style }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { en: { populationHealth } } = useSelector((state) => state.i18n);
  const { dateRange } = useSelector((state) => state.populationHealth);

  const handleDateChange = useCallback((newDate) => {
    if (!newDate) {
      dispatch(setDateRange({
        startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), // 30 days ago
        endDate: new Date(),
      }));
    } else {
      if (!newDate[0] || !newDate[1]) {
        dispatch(setDateRange({
          startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), // 30 days ago
          endDate: new Date(),
        }));
      } else {
        dispatch(setDateRange({ startDate: newDate[0], endDate: newDate[1] }));
      }
    }
  }, [dispatch]);

  const handleClear = useCallback(() => {
    dispatch(setDateRange({
      startDate: null,
      endDate: null,
    }));
  }, [dispatch]);

  return (
    <div className={classes.controlGroup} style={style}>
      <Typography className={classes.sectionTitle}>
        {populationHealth?.dateRange || 'Date Range'}
      </Typography>
      <div className={classes.dateContainer}>
        <div className={classes.calendarWrapper}>
          <CalendarPopover
            shouldRange={true}
            onChange={handleDateChange}
            date={[dateRange.startDate, dateRange.endDate]}
            maxDate={new Date()}
            width="100%"
            shouldReduceFontSize={false}
            shortView={false}
            placeholder="Select date range"
            updateAfterChanging
            inputClass={classes.inputClass}
            inputPlaceholderClass={classes.inputPlaceholderClass}
          />
        </div>
        <IconButton
          className={classes.clearButton}
          onClick={handleClear}
          size="small"
          title="Clear date range"
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  );
};

export default DateRangeFilter;
